import {
  EMAIL_REPORT_LOADING,
  EMAIL_REPORT_LOADED,
  EMAIL_REPORT_COMPANIES_LOADED,
  EMAIL_REPORT_NEW_COMPANY_SELECTED,
  EMAIL_ALL_COMPANIES_LOADING,
  EMAIL_ALL_COMPANIES_LOADED,
  EMAIL_REPORT_EDIT_LOADED
} from '../components/actions/emailReportsTypes'



function getDayOptions() {
  let dayCount = 28;
  let dayOfMonthOptions = [];

  for (let index = 1; index <= dayCount; index++) {
    dayOfMonthOptions.push({ label: index, value: index});
  }

  return dayOfMonthOptions;
}

const initialState = {
  loading: true,
  exportLoading: false,
  companiesLoading: true,
  allCompanyList: null,
  emailReportList: null,
  selectedCompany: null,
  loadedReport: null,
  dayOfMonthOptions: getDayOptions()
}

const emailReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_REPORT_LOADING:
      state.loading = true
      return state
    case EMAIL_REPORT_LOADED:
      state.loading = false
      return state
    case EMAIL_ALL_COMPANIES_LOADING:
      state.companiesLoading = true
      return state
    case EMAIL_ALL_COMPANIES_LOADED:
      state.companiesLoading = false
      state.loadedReport = null
      state.allCompanyList = action.payload
      return state
    case EMAIL_REPORT_COMPANIES_LOADED:
      state.loading = false
      state.emailReportList = action.payload
      return state
    case EMAIL_REPORT_EDIT_LOADED:
      state.companiesLoading = false
      state.allCompanyList = action.payload.companiesData
      state.loadedReport = action.payload.savedData
      return state
    case EMAIL_REPORT_NEW_COMPANY_SELECTED:
      state.selectedCompany = state.allCompanyList.find((c) => c.value === action.payload.value)
      return state
    default:
      return state
  }
}

export default emailReportsReducer
